// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ObrigadoRouteImport } from './routes/obrigado'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const ObrigadoRoute = ObrigadoRouteImport.update({
            id: '/obrigado',path: '/obrigado',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRoute,ObrigadoRoute: ObrigadoRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)